import React, { useEffect, useState } from "react";
import { Button ,Row,Col, Select, Calendar , Typography, message} from "antd";
import './render-tabs.style.scss';
import { addMonth, firstDayOfMonth, getAPIDateFormat, getDate, getDateMonthInReadable , getMonth, lastDayOfMonth, subtractMonth,getDates } from "../../../utils/date.utils";
import { formateDataByDate, getActiveStatus, getDynamicPricingClassName, informRedBusAboutDeRegister, informRedBusAboutRegister, informSciativeAboutDeRegister, informSciativeAboutRegister } from "./render-tabs.module";
import { getSchedulesByIdForDates } from "../../../actions/admin.action";
import { REDBUS_DP_PROVIDER, SCIATIVE_DP_PROVIDER } from "../../../utils/constant";
import { loadingAction } from "../../../actions/loading-actions";
import { useDispatch } from "react-redux";
import { CalenderColorLegend } from "../calender-color-legend/calender-color-legend";
import { isValid } from "../../../utils/utilities";

const {Option} = Select;
const { Text } = Typography;

export const DynamicPricingTabComponent = (props) => {

        const{
            selectedDate,
            isMobile,
            scheduleData,
            isDynamicPricingOpened
        } = props;

        const [currentDate , setCurrentDate] = useState(selectedDate);
        const [nextDate , setNextDate] = useState(selectedDate);
        const [currentSelectedDate , setCurrentSelectedDates] = useState(null);
        const [openCalenderData , setOpenCalenderData] = useState({});

        const dispatch = useDispatch();


        useEffect(()=>{
            if(isDynamicPricingOpened){
                reload();
            }
        },[isDynamicPricingOpened,currentDate]);

        useEffect(()=>{
            setCurrentDate(selectedDate);
        },[selectedDate]);

        useEffect(()=>{
            let secondDate = addMonth(currentDate,1);
            setNextDate(secondDate);
        },[currentDate]);

        let currentMonth = getMonth(currentDate);
        let nextMonth = getMonth(nextDate);

        /*
            Reads the trips of the shown months so that the calendar can mark which
            dates run on dynamic pricing.
        */
        const reload=()=>{
            let sqlStartDate = firstDayOfMonth(currentDate);
            let sqlNextDate = lastDayOfMonth(currentDate);
            if(!isMobile){
                sqlNextDate = lastDayOfMonth(addMonth(currentDate,1));
            }
            setLoading(true);
            getSchedulesByIdForDates(scheduleData.id,sqlStartDate,sqlNextDate,onCalenderDataSuccess,onFailure);
        }

        const onCalenderDataSuccess=(activeData)=>{
            setLoading(false);
            setOpenCalenderData(formateDataByDate(activeData));
        }

        const onSuccess=(msg)=>{
            setLoading(false);
            setCurrentSelectedDates(null);
            message.success(msg);
            // Registering/de registering flips dynamic pricing on the trips
            reload();
        }

        const setLoading = (value)=>{
            dispatch(loadingAction(value));
        }

        const onFailure=(err)=>{
            setLoading(false);
            message.error(err)
        }


        // The tab holds the register/de register of whichever provider the operator
        // runs dynamic pricing on.
        const provider = global.dynamicPricingProvider;
        const isRedBus = provider === REDBUS_DP_PROVIDER;
        const isSciative = provider === SCIATIVE_DP_PROVIDER;

        const onRegisterClick =()=>{
            if(!isValid(currentSelectedDate)){
                message.error("Please select start date.");
                return;
            }
            if(isRedBus){
                setLoading(true);
                informRedBusAboutRegister(scheduleData.id,currentSelectedDate,onSuccess,onFailure);
            }else if(isSciative){
                setLoading(true);
                informSciativeAboutRegister(scheduleData.id,currentSelectedDate,onSuccess,onFailure);
            }else{
                message.error("Dynamic pricing provider is not configured.");
            }
        }

        const onDeRegisterClick =()=>{
            if(isRedBus){
                setLoading(true);
                informRedBusAboutDeRegister(scheduleData.id,onSuccess,onFailure);
            }else if(isSciative){
                setLoading(true);
                informSciativeAboutDeRegister(scheduleData.id,onSuccess,onFailure);
            }else{
                message.error("Dynamic pricing provider is not configured.");
            }
        }

        const onPreviousClick =()=>{
            if(isMobile){
                setCurrentDate(subtractMonth(currentDate,1));
            }else{
                setCurrentDate(subtractMonth(currentDate,2));
            }
        }

        const onNextClick =()=>{
            if(isMobile){
                setCurrentDate(addMonth(currentDate,1));
            }else{
                setCurrentDate(addMonth(currentDate,2));
            }
        }


        return(
            <div className="extend-block-root">
                <Row gutter={[16,16]} justify="center" align="middle">
                    <Col>
                        <div className="site-extended-calendar">
                            <Calendar 
                                value={currentDate}
                                fullscreen={false}
                                headerRender={()=>{
                                    return (
                                    <Row gutter={[16,16]} align="middle">
                                        <Col>
                                            <Button type="link" className="previous-calender-btn" onClick={onPreviousClick}>
                                                <Text className="normal-txt">Previous</Text>
                                            </Button>
                                        </Col>
                                        <Col>
                                            <Text strong>{getDateMonthInReadable(currentDate)}</Text>
                                        </Col>  
                                        {isMobile&&
                                            <Col>
                                                <Button type="link" className="previous-calender-btn" onClick={onNextClick}>
                                                    <Text className="normal-txt">Next</Text>
                                                </Button>
                                            </Col>
                                        }      
                                    </Row>
                                    )              
                                }}
                                dateFullCellRender={(date)=>{
                                    let day = getDate(date);
                                    let month = getMonth(date);
                                    if(month===currentMonth){
                                        let apidate = getAPIDateFormat(date);
                                        let {
                                            className,
                                            styles
                                        } = getActiveStatus(openCalenderData,apidate);
                                        let index = [currentSelectedDate].indexOf(apidate);
                                        let selectedClassName = index!=-1?"schedule-date-selected":"";
                                        let dynamicPricingClassName = getDynamicPricingClassName(openCalenderData,apidate);
                                        return (
                                            <div 
                                            className={`current-date ${className} ${dynamicPricingClassName} edit-fare-date-block`} style={styles}>
                                                <div className={`${selectedClassName}`}>{day}</div>
                                            </div>
                                        )
                                    }else{
                                        return (
                                            <div className={`next-month-date`}>
                                                <div>{day}</div>
                                            </div>
                                        )
                                    }
                                }}
                                mode="month"
                                onSelect={(date)=>{
                                    let apidate = getAPIDateFormat(date);
                                    setCurrentSelectedDates(apidate);
                                }}
                            />
                        </div>
                    </Col>
                    {!isMobile&&
                    <Col>
                            <div className="site-extended-calendar">
                                <Calendar 
                                            value={nextDate}
                                            fullscreen={false}
                                            headerRender={()=>{
                                                return (
                                                <Row gutter={[16,16]} align="middle" justify="end">
                                                    <Col>
                                                        <Text strong>{getDateMonthInReadable(nextDate)}</Text>
                                                    </Col>
                                                    <Col>
                                                        <Button type="link" className="previous-calender-btn" onClick={onNextClick}>
                                                            <Text className="normal-txt">Next</Text>
                                                        </Button>
                                                    </Col>
                                                </Row>
                                                )              
                                            }}
                                            dateFullCellRender={(date)=>{
                                                let day = getDate(date);
                                                let month = getMonth(date);
                                                if(month===nextMonth){
                                                    let apidate = getAPIDateFormat(date);
                                                    let {
                                                        className,
                                                        styles
                                                    } = getActiveStatus(openCalenderData,apidate);
                                                    let index = [currentSelectedDate].indexOf(apidate);
                                                    let selectedClassName = index!=-1?"schedule-date-selected":"";
                                                    let dynamicPricingClassName = getDynamicPricingClassName(openCalenderData,apidate);
                                                    return (
                                                        <div 
                                                            className={`current-date ${className} ${dynamicPricingClassName} edit-fare-date-block`} style={styles}>
                                                            <div className={`${selectedClassName}`}>{day}</div>
                                                        </div>
                                                    )
                                                }else{
                                                    return (
                                                        <div className={`next-month-date`}>
                                                            <div>{day}</div>
                                                        </div>
                                                    )
                                                }
                                            }}
                                            mode="month"
                                            onSelect={(date)=>{
                                                let apidate = getAPIDateFormat(date);
                                                setCurrentSelectedDates(apidate);
                                            }}
                                        />
                            </div>
                        </Col>
                    }
                </Row>
                <Row gutter={[16,16]} justify="center" align="middle">
                    <Col>
                        <Select
                        placeholder="Select Dates"
                        className="schedule-date-select"
                        onChange={(value)=>{
                                let dates = getDates(value);
                                setCurrentSelectedDates(dates[0]);
                        }}
                        >
                            <Option value={'today'}>Today</Option>
                            <Option value={'tomorrow'}>Tomorrow</Option>
                        </Select>
                    </Col>
                </Row>
                <Row gutter={[16,16]} align="center">
                    <Col>
                        <CalenderColorLegend />
                    </Col>
                    <Col>
                        <Button onClick={onRegisterClick}>{`Register ${provider} DP`}</Button>
                    </Col>
                    <Col>
                        <Button onClick={onDeRegisterClick}>{`DeRegister ${provider} DP`}</Button>
                    </Col>
                </Row>
            </div>
        )
}
